import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function NotificationCardLayout({
  icon: Icon,
  iconBg,
  iconColor,
  title,
  applicationEid,
  applicantNames,
  onClick,
  count,
  children,
}: {
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
  title: string;
  applicationEid?: string;
  applicantNames?: string;
  onClick: () => void;
  count?: number;
  children: ReactNode;
}) {
  const label = applicantNames || applicationEid;
  return (
    <button type="button" onClick={onClick} className="flex w-full items-start gap-3 text-left">
      <div
        className={`relative mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${iconBg} ${iconColor}`}
      >
        <Icon className="h-4 w-4" />
        {count != null && count > 1 && (
          <span className="absolute -right-1.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-0.5 text-[10px] font-bold leading-none text-primary-foreground">
            {count}
          </span>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-medium text-muted-foreground">
          {title}
          {label ? ` · ${label}` : ""}
        </p>
        {children}
      </div>
    </button>
  );
}
